<template>
  <v-dialog v-model="dialogdetailfriend" persistent max-width="500px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <!-- <span style="color: white;">{{status}} | {{id}} | {{type}} {{relation_friend}}</span> -->
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
        <v-container grid-list-md>
          <v-layout wrap >
            <v-flex sm12 md12 lg12 xl12>
              <div v-if="type_friend=='friend' && status_search=='success'">
                <img :src="picture_Friend" class="pictureProfile" @click="openPictureProfile()">
                <br>
                <div class="CSChatThai" style="text-align:center">
                  <h3>{{result_search.name}}</h3>
                 {{result_search.status}}
                </div>
                <br>
                <v-btn @click="chat(result_search.tokenroom)" v-if="relation_friend=='friend'" class="chatbtn">
                  {{$t('AnswerQuestion.chat')}}
                </v-btn>
                <v-btn @click="AcceptReq(result_search.tokenuser)" v-else-if="relation_friend=='request'" class="chatbtn">
                  {{$t('AnswerQuestion.acceptFriend')}}
                </v-btn>
                <v-btn @click="RemoveReq(result_search.tokenuser)" v-else-if="relation_friend=='sendrequest'" class="canclebtn">
                  {{$t('AnswerQuestion.cancelRequest')}}
                </v-btn>
                <v-btn @click="closeDialog()" v-else-if="relation_friend=='self'" class="chatbtn">
                  {{$t('AnswerQuestion.ok')}}
                </v-btn>
                <v-btn @click="AddFriend(result_search.tokenuser)" v-else-if="relation_friend=='unknown' || relation_friend=='unfriend'" class="chatbtn">
                  {{$t('AnswerQuestion.addFriend')}}
                </v-btn>
                <v-btn @click="unblock(result_search.tokenuser, result_search.tokenroom)" v-else-if="relation_friend=='block'"class="canclebtn">
                  {{$t('AnswerQuestion.unblock')}}
                </v-btn>
              </div>
              <div v-else-if="type_friend=='group' && status_search=='success'">
                 <img :src="picture_Group" class="pictureProfile" @click="openPictureGroup()">
                <div class="CSChatThai" style="text-align:center">
                <h3>{{result_search.name}}</h3>
              </div>
              <br>
              <v-btn @click="AcceptGroup(result_search.group_id)" class="chatbtn" v-if="result_search.state != 'active'">
                {{$t('AnswerQuestion.joinGroup')}}
              </v-btn>
              <v-btn @click="chat(result_search.tokenroom)" class="chatbtn" v-else>
                {{$t('AnswerQuestion.chat')}}
              </v-btn>
              </div>
              <div v-else-if="status_search === 'loading'">
                <v-progress-linear
                  color="light-blue darken-4"
                  indeterminate
                  height="6"
                ></v-progress-linear>
              </div>
              <div class="CSChatThai" style="text-align:center" v-else>
                <h3>ไม่พบข้อมูล</h3>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
  </v-dialog>
</template>
<script>
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'

export default {
  props: {
    'dialogdetailfriend': false,
    relation: '',
    result: {},
    pictureFriend: '',
    pictureGroup: '',
    status: '',
    id: '',
    type: ''
  },
  data: () => ({
    token: '',
    result_search: {},
    relation_friend: '',
    picture_Friend: '',
    picture_Group: '',
    status_search: 'loading',
    id_friend: '',
    type_friend: '',
    dialogshowimage_profile: false,
    pathpicture: '',
    typepathpicture: ''
  }),
  components: {
    ShowImageProfileDialog
  },
  watch: {
    dialogdetailfriend () {
      console.log(this.dialogdetailfriend)
      this.result_search = this.result
      this.relation_friend = this.relation
      this.picture_Friend = this.pictureFriend
      this.picture_Group = this.pictureGroup
      this.status_search = this.status
      this.id_friend = this.id
      this.type_friend = this.type
    }
  },
  methods: {
    openPictureProfile () {
      this.pathpicture = this.result_search.profilepicture
      this.typepathpicture = this.result_search.type
      this.dialogshowimage_profile = true
    },
    openPictureGroup () {
      this.pathpicture = this.result_search.picture
      this.typepathpicture = 'group'
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    AcceptGroup (group_id) {
      this.axios.post(process.env.APImanage + '/joingroup', {
        group_id: group_id,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response)
        this.socketactive_group = {timestamp: '', groupid: group_id, tokenuser: this.token}
        this.closeDialog()
      })
    },
    chat (tokenroom) {
      this.$router.push('/chat/room/' + tokenroom)
      this.closeDialog()
    },
    AcceptReq (tokenFriend) {
      this.axios.post(process.env.APInew_acceptfriend, {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation_friend = 'friend'
          this.result_search['tokenroom'] = response.data.tokenroom
          this.socketaccept_friend = { tokenuser: this.token, tokenfriend: tokenFriend, tokenroom: response.data.tokenroom }
          // this.closeDialog()
        }
      })
    },
    RemoveReq (tokenFriend) {
      // console.log(tokenFriend)
      this.axios.post(process.env.APImanage + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          this.relation_friend = 'unknown'
          this.socketremove_request_friend = {
            tokenuser: tokenFriend,
            tokenfriend: this.token
          }
          // this.closeDialog()
        }
      })
    },
    AddFriend (tokenFriend) {
      // console.log(tokenFriend)
      this.axios.post(process.env.APInew_addfriend, {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation_friend = 'sendrequest'
          this.socketfriend = { tokenfriend: [tokenFriend], konAdd: this.token }
          // console.log(this.socketfriend)
          // this.$store.dispatch('sendRequest', tokenFriend)
          // this.closeDialog()
        } else {
          alert('Error!!!')
        }
      })
    },
    unblock (tokenFriend, tokenroom) {
      this.axios.post(process.env.APImanage + '/unblockfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token,
        tokenroom: tokenroom
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.$swal(
            'Unblocked!',
            this.$t('Alert.Success.unblock'),
            'success'
          )
          this.relation_friend = 'friend'
          this.result_search['state'] = 'friend'
          this.result_search['event'] = 'unblock_friend'
          this.block_friend = this.result_search
        }
      })
    },
    findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    closeDialog () {
      this.status_search = 'loading'
      this.result_search = {}
      this.relation_friend = ''
      this.picture_Friend = ''
      this.picture_Group = ''
      this.id_friend = '',
      this.type_friend = ''
      this.$emit('closeDialog', false)
    }
  },
  computed: {
    ...sync('*')
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // console.log(this.tokenuserQR)
  }
}
</script>
<style type="text/css" scoped>
.chatbtn {
  display: flex;
  border-radius: 10px;
  margin: auto;
  margin-top: 5px;
  background: #2562af !important;
  color: white !important;
  text-transform: none;
}
.canclebtn {
  display: flex;
  border-radius: 10px;
  margin: auto;
  margin-top: 5px;
  background: #ff5252 !important;
  color: white !important;
  text-transform: none;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.pictureProfile {
  border: 1px solid #1a222b;
  display: flex;
  margin: auto;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  object-position: 50% 0;
  cursor: pointer;
}
/*.application .theme--light.input-group:not(.input-group--error) label, .theme--light .input-group:not(.input-group--error) label {
  color: #5ed1ff !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_friend/DetailFriendDialog.vue